import React from 'react';
import AutoRajaPageNav from './AutoRajaPageNav';

const LegalPageLayout = ({ route, kicker, title, navigateToPath, children }) => (
  <main className="content">
    <section className="section autoraja-legal-page">
      <div className="container">
        <AutoRajaPageNav route={route} navigateToPath={navigateToPath} />
        <header className="legal-heading">
          <p className="section-kicker">{kicker}</p>
          <h1>{title}</h1>
        </header>
        <div className="legal-content">{children}</div>
      </div>
    </section>
  </main>
);

export default LegalPageLayout;
